<template>
  <div
    data-pendo-ds="text_input"
    :style="{ width, 'max-width': '100%' }"
  >
    <label class="body-s-high">
      <InputLabel
        v-if="label"
        :info="info"
        :label="label"
        :required="required"
        :style="{ 'margin-bottom': 'var(--space-1)' }"
      />
      <div style="position: relative;">
        <input
          class="body-s-regular cr-br-small"
          :class="{
            'error': error,
          }"
          :data-testid="`${id}_text_input`"
          :disabled="disabled"
          :placeholder="placeholder"
          :readonly="readOnly"
          :type="password && !showPassword ? 'password' : 'text'"
          :value="value"
          @blur="$emit('blur', $event)"
          @input="$emit('update:value', $event.target.value)"
        >
        <BaseButton
          v-if="password"
          class="text-input__password-toggle"
          emphasis="low"
          :icon="passwordToggleIcon"
          icon-font-size="var(--font-size-2)"
          theme="mono"
          @click.prevent="showPassword = !showPassword"
        />
      </div>
    </label>
    <slot
      v-if="!error"
      name="footer"
    >
      <div class="label-s-regular text-input__footer">
        {{ subtext }}
      </div>
    </slot>
    <slot name="errors" />
  </div>
</template>

<script>
import BaseButton from './BaseButton.vue'
import InputLabel from './InputLabel.vue'

export default {
  name: 'TextInput',
  components: {
    InputLabel,
    BaseButton,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '100%',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    info: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    subtext: {
      type: String,
      default: '',
    },
    password: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:value', 'blur'],
  data: () => ({
    showPassword: false,
  }),
  computed: {
    passwordToggleIcon() {
      return this.showPassword ? 'fa-eye' : 'fa-eye-slash'
    },
  },
}
</script>

<style scoped lang="scss">
label, input {
  display: block;
  margin: 0;
}

.text-input__footer {
  margin-top: var(--space-2);
  margin-left: var(--space-2);
  color: var(--pepper-700);
}

:deep(.text-input__password-toggle) {
  svg {
    width: var(--font-size-4);
  }
}

.text-input__password-toggle:hover {
  box-shadow: none;
}

.text-input__password-toggle:focus {
  box-shadow: none;
}

.text-input__password-toggle {
  position: absolute;
  right: 0;
  bottom: 0;
}

input {
  width: 100%;
  padding: .65rem var(--space-2);
  border: 1px solid var(--pepper-300);
  outline: none;

  &:disabled {
    color: var(--pepper-600);
    background-color: var(--pepper-200);
  }

  &:focus {
    border-color: var(--blueberry-1000);
  }

  &::placeholder {
    color: var(--pepper-600);
  }

  &.error {
    border: 1px solid var(--chicago-dog-red-1000);
    &:focus-visible {
      outline: 2px solid var(--blueberry-300);
    }
  }
}
</style>
